import { Button, Divider, Form, Input, Modal, notification, Typography } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { coreApi } from "../../api/calls";
import UserAccountTypeSelect from "./UserAccountTypeSelect";

const UserAddForm = ({ employee, setEmployee = null }) => {
  const { t } = useTranslation();

  const [isModalOpen, setModalOpen] = useState(false);

  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const [userForm] = Form.useForm();

  // Removed account of the employee, which will be restored instead of creating a new one
  const removedUser = employee?.user?.deleted_at ? employee.user : null;

  return submitted ? (
    <Typography.Paragraph>{t("users.userAdded")}</Typography.Paragraph>
  ) : (
    <React.Fragment>
      <Typography.Paragraph>{t("users.employeeHasNoUserAccount")}</Typography.Paragraph>
      {removedUser && (
        <Typography.Paragraph>
          {t("users.accessWillBeRestored", { username: removedUser.username, email: removedUser.email })}
        </Typography.Paragraph>
      )}
      <Divider></Divider>
      <Button
        type={"primary"}
        onClick={() => {
          setModalOpen(true);
        }}
      >
        {t("users.addUserAccount")}
      </Button>
      <Modal
        title={t("users.addUserAccount")}
        open={isModalOpen}
        onOk={() => {
          userForm.submit();
        }}
        okButtonProps={{ loading: submitting }}
        onCancel={() => {
          setModalOpen(false);
        }}
      >
        <Form
          form={userForm}
          onFinish={(values) => {
            setSubmitting(true);

            coreApi
              .post("/users", values)
              .then((response) => {
                if (response.data.mail_sent === false) {
                  notification.warning({ message: response.data.message });
                } else {
                  notification.success({ message: response.data.message });
                }
                setModalOpen(false);
                userForm.resetFields();

                if (setEmployee && response.data.user) {
                  setEmployee({ ...employee, user: response.data.user });
                } else {
                  setSubmitted(true);
                }
              })
              .catch((error) => {
                // Validation errors are already notified by the coreApi interceptor
                if (error?.response?.status === 422) {
                  const errors = error.response.data?.errors ?? {};

                  userForm.setFields(Object.keys(errors).map((field) => ({ name: field, errors: errors[field] })));
                } else {
                  notification.error({ message: error?.response?.data?.message });
                }
              })
              .finally(() => {
                setSubmitting(false);
              });
          }}
        >
          <Form.Item name={"employee_id"} initialValue={employee?.id} hidden>
            <Input></Input>
          </Form.Item>
          <Form.Item
            name={"username"}
            label={t("users.username")}
            initialValue={removedUser?.username}
            rules={[{ required: true, min: 6 }]}
            hasFeedback
          >
            <Input></Input>
          </Form.Item>
          <Form.Item
            name={"email"}
            label={t("users.email")}
            initialValue={removedUser ? removedUser.email : (employee?.email_work ?? employee?.email_personal)}
            rules={[
              {
                required: true,
              },
              {
                type: "email",
                message: t("common.emailValidation"),
              },
            ]}
            hasFeedback
          >
            <Input></Input>
          </Form.Item>
          <UserAccountTypeSelect initialValue={removedUser ? Boolean(removedUser.is_admin) : undefined} />
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default UserAddForm;
